import { AppEnities, captchaLength, CasiEventName, DrawItemNames } from "./constants.lib";

import { environment } from '../../environments/environment';
import { IProject } from "../models/models.lib";
import { isNotNull } from "./utils.lib";

const { apiUrl } = environment;

export class UserEnquiry {
  static create(args: any) {
    const {
      phone, message,
      firstName, lastName,
      email, id
    } = args;
    return new UserEnquiry(
      email, message, id,
      firstName, lastName,
      phone
    );
  };

  constructor(
    public email: string,
    public message: string,
    public id?: number,
    public firstName?: string,
    public lastName?: string,
    public phone?: string,) { }


  forSubmit(): any {
    return {
      message: this.message,
      first_name: this.firstName || null,
      last_name: this.lastName || null,
      email: this.email,
      phone: this.phone || null,
      user_id: this.id || null
    };
  }
};

export class AccountApplication {
  static create(args: any, acceptedTermsVersion?: number) {
    const {
      password, email, first_name, last_name, phone, newsletter, research_consent
    } = args;
    return new AccountApplication(
      password, email,
      first_name, last_name,
      phone,
      acceptedTermsVersion,
       newsletter, research_consent
    );
  };

  constructor(
    public password: string,
    public email: string,
    public firstName?: string,
    public lastName?: string,
    public phone?: string,
    public acceptedTermsVersion?:number,
    public newsletter: boolean = false,
    public research_consent: boolean = false
  ) { }

  get lastLogin() {
    return this.email;
  }

  forSubmit(): any {
    return {
      password: this.password,
      email: this.email,
      first_name: this.firstName || null,
      last_name: this.lastName || null,
      phone: this.phone || null,
      newsletter: this.newsletter || false,
      research_consent: this.research_consent || false,
      accepted_terms_version: this.acceptedTermsVersion || null
    };
  }
};

export interface IMenuItem {
  id: number,
  title: string,
  url: string,
  entity?: AppEnities
};

export class MenuItem implements IMenuItem {
  static create(args: any) {
    const {
      id,
      title, url, entity
    } = args;
    return new MenuItem(id, title, url, entity);
  }

  constructor(
    public id: number,
    public title: string,
    public url: string,
    public entity?: AppEnities
  ) { }
};

export interface IEnvVars {
  // version: string
  pollingPeriod?: number;
  overrideDefaults?: boolean;
  // cwd?: string;
}

export const appDefaults = <IEnvVars>{
  pollingPeriod: 60000,
  overrideDefaults: true
}

export interface ISettings {
  apiUrl: string;
  email?: string;
  pollingPeriod: number;
  dbUser?: string;
  dbUserPw?: string;
  tunnelUsername?: string;
  tunnelUserPw?: string;
  tunnelDbUsername?: string;
  tunnelDbPw?: string;
  currentProject?: IProject;
  app_last_directory?: string;
  lastEmail?: string;
};

export class Settings implements ISettings {

  static initialise(apiUrl: string, pollingPeriod: number = 60000, appLastDirectory?: string) {
    return new Settings({
      apiUrl: apiUrl,
      pollingPeriod: pollingPeriod,
      app_last_directory: appLastDirectory
    });
  }

  apiUrl: string = '';
  email?: string | undefined;
  pollingPeriod: number = 60000;
  dbUser?: string | undefined;
  dbUserPw?: string | undefined;
  tunnelUsername?: string | undefined;
  tunnelUserPw?: string | undefined;
  tunnelDbUsername?: string | undefined;
  tunnelDbPw?: string | undefined;
  app_last_directory?: string | undefined;
  currentProject?: IProject | undefined;
  lastEmail?: string | undefined;

  constructor(partial: Partial<Settings>) {
    Object.assign(this, partial);
    // console.log('Setting:contructor: partial', partial);
    // console.log('Setting:contructor: this', this);

  }
};

export interface ICasiEvent {
  event: CasiEventName;
  target?: string;
};

export class CasiEvent implements ICasiEvent {
  constructor(
    public event: CasiEventName,
    public target?: string
  ) { }
};

export enum CasiTileComponentName {
  MyWork = 'MyWorkComponent',
  CurrentBacklog = 'CurrentIterationComponent',
  Test1 = 'Test1Component'
}

export interface ICasiTileComponent {
  name: CasiTileComponentName;
  component: any
}

export interface ITileItem {
  title: string;
  col: number;
  row?: number;
  colSpan: number;
  component: CasiTileComponentName;
  name: string;
  ref: DrawItemNames;
  showAdd: boolean;
  menuContext: any[];
  tileComponentPool: any[]
}

export class TileItem implements ITileItem {
  static create(args: ITileItem, pool: any[]) {
    const { title, col, component, name, ref, row, colSpan, showAdd, menuContext } = args;
    // console.log(`TileItem:create: `, JSON.stringify(args));
    // console.log(`TileItem:create: showAdd`, showAdd, !!showAdd);
    return new TileItem(
      title, name, col, colSpan, component, ref, !!showAdd, menuContext ? menuContext : [],
      pool, row,
    );
  }

  constructor(
    public title: string,
    public name: string,
    public col: number,
    public colSpan: number,
    public component: CasiTileComponentName,
    public ref: DrawItemNames,
    public showAdd: boolean,
    public menuContext: any[],
    public tileComponentPool: any[],
    public row?: number
  ) { }

  get componentName() {
    return `_${this.component}`;
  };

  get componentActual() {
    let toReturn = this.tileComponentPool.find(t => t.name === this.component);
    // console.log(`TileItem:componentActual:toReturn: `, toReturn);
    if (!toReturn)
      return undefined;
    return toReturn?.component;
  }
}

export interface ITrackerStates {
  selectedTiles: ITileItem[];
  currentProject?: IProject;
}

export class TrackerStates implements ITrackerStates {

  static initialise(initialTiles: TileItem[] = []) {
    return new TrackerStates({
      selectedTiles: initialTiles
    });
  }

  static reCreate(args: ITrackerStates, pool: any) {
    let tileCollection: TileItem[] = [];
    if (args && args.selectedTiles.length > 0) {
      for (let tile of args.selectedTiles) {
        tileCollection.push(TileItem.create(tile, pool));
      }
    }
    return new TrackerStates({
      selectedTiles: tileCollection,
      currentProject: args.currentProject
    });
  }

  selectedTiles: TileItem[] = [];
  currentProject?: IProject | undefined;

  constructor(partial: Partial<TrackerStates>) {
    Object.assign(this, partial);
  }
}

export interface IUserStorySearchOptions {
  email: string;
  searchStr?: string;
  dashboardStr: string;
  projectId?: number;
  projectLabelId?: number;
  userStoryTypeId?: number;
  userStoryEstimateId?: number;
  userStoryPriorityId?: number;
  requestedByUserId?: number;
  ownedByUserId?: number;
}

export class UserStorySearchOptions implements IUserStorySearchOptions {
  email: string = '';
  searchStr?: string;
  dashboardStr: string = storyOptions[0].value;
  projectId?: number;
  projectLabelId?: number;
  userStoryTypeId?: number;
  userStoryEstimateId?: number;
  userStoryPriorityId?: number;
  requestedByUserId?: number;
  ownedByUserId?: number;

  constructor(partial: Partial<UserStorySearchOptions>) {
    Object.assign(this, partial);
  }

  // constructor(
  //   public dashboardStr: string,
  //   public projectId: number | null,
  //   public projectLabelId: number | null,
  //   public userStoryTypeId: number | null,
  //   public userStoryEstimateId: number | null,
  //   public userStoryPriorityId: number | null,
  //   public requestedByUserId: number | null,
  //   public ownedByUserId: number | null
  // ) {

  // }

};

export type StoryOptionType = { text: string, value: string };

export const storyOptions: Array<StoryOptionType> = [
  { text: "Current", value: "Current" },
  { text: "All", value: "dashboard" }
];

export interface ImageInfo {
  src: string;
  width: number;
  height: number;
}

export interface ICasiFileInfo {
  uid: string;
  filename: string;
  tablename: string;
  userStoryId: number;
  apiUrl: string;
  filePackage: string;
  buildHRef(apiUrl: string): string;
  buildLink(apiUrl: string): string;
  buildFileObject(apiUrl: string): any;
}

export class CasiFileInfo implements ICasiFileInfo {
  uid: string = 'Not set';
  filename: string = 'Not set';
  tablename: string = 'Not set';
  apiUrl: string = 'Not set';
  userStoryId: number = -1;
  filePackage: string = 'Not set';

  buildHRef(): string {
    // return `${this.apiUrl}/getfile/${this.tablename}/${this.userStoryId}?fname=${encodeURIComponent(this.filename)}__token__`;
    // return `${this.apiUrl}/getfile/${this.tablename}/${this.userStoryId}?fname=${encodeURIComponent(this.filename)}`;
    return `${this.apiUrl}/getfile/${encodeURIComponent(this.filePackage)}`;
    // return `<br><a href="${apiUrl}/getfile/${this.tablename}/${this.userStoryId}/${this.filename}" target="_blank">${this.filename}</a>`;
  }
  buildLink(): string {
    // return `${apiUrl}/getfile/${this.tablename}/${this.userStoryId}/${this.filename}`;
    return `<br><a href="${this.buildHRef()}" target="_blank">${this.filename}</a>`;
  }
  buildFileObject() {
    return {
      href: this.buildHRef(),
      title: this.filename,
      target: "_blank"
    }
  }
  constructor(partial: Partial<CasiFileInfo>) {
    Object.assign(this, partial);
  }
}

export type DoneCallback = (error?: any | null, results?: any | null | undefined) => void;

export type condFn = (a: any) => boolean;

export class RuleEval {
  ruleSet = new Map<condFn, any>();
  addRule(rule: condFn, result: any) {
    this.ruleSet.set(rule, result);
  }
  evalRules(domain: any) {
    for (const [rule, result] of this.ruleSet) {
      if (rule(domain)) return { rule: rule, result: result };
    }
    return { rule: 'Do nothing', result: 'do_nothing' };
  }
};

export class CaptchaMeta {
  captchaImage: string = '';
  captchaText: string = '';
  iamhuman: boolean | undefined;
  checkCaptchaText: boolean = false;
  captchaErrorMsg: string = 'Captcha text is required';
  minLength: number = captchaLength;

  constructor() {
    // this.minLength = captchLength;
  }

  resetFlags() {
    this.captchaText = '';
    this.iamhuman = undefined;
    this.checkCaptchaText = false;
    this.captchaErrorMsg = 'Captcha text is required';
  }

  get hasText() {
    // logger.debug(`hasText:`, { notnot: !!this.captchaText, text: this.captchaText })
    return !!this.captchaText === true;
  }
  get textLength() {
    if (this.hasText)
      return this.captchaText.length;
    return 0;
  }

  get hasCaptchaErrors() {
    let hasErrors = false;
    if (!this.captchaText) {
      // logger.debug(`hasCaptchaErrors:no captcha text...`)
      hasErrors = true;
    }
    if (this.hasText && this.captchaText.length !== captchaLength) {
      // logger.debug(`hasCaptchaErrors: captcha text length not correct...`)
      hasErrors = true;
    }
    if (!!this.iamhuman === false) {
      // logger.debug(`hasCaptchaErrors: captcha iamhuman false...`)
      hasErrors = true;
    }
    return hasErrors;
  }
}

export class TermsResponse {
  version: number = 0;
  content: string = "";

  static create(resp: any) {
    const { version_number, html } = resp;
    return new TermsResponse(+version_number, html);
  }
  constructor(version: number = 0, content: string = '') {
    this.version = version;
    this.content = content;
  }
}

export class EmailSearchResult {
  searchedEmail: string = "";
  found: boolean = false;
  id: number | null | undefined;
  first_name: string | null | undefined;
  last_name: string | null | undefined;
  active: boolean | null | undefined;
  email: string | null | undefined;

  static create(searchedEmail: string | null = '',
    found: boolean = false,
    args: any = null) {
    if (isNotNull(args)) {
      const {
        id,
        first_name, last_name, email, active
      } = args;
      return new EmailSearchResult(!!searchedEmail ? searchedEmail : "", found,
        id, first_name, last_name, active, email
      );
    }
    return new EmailSearchResult(!!searchedEmail ? searchedEmail : "", found);
  }

  constructor(
    searchedEmail: string,
    found: boolean = false,
    id = null,
    first_name = null,
    last_name = null,
    active = null,
    email = null
  ) {
    this.searchedEmail = searchedEmail;
    this.found = found;
    this.id = id;
    this.first_name = first_name;
    this.last_name = last_name;
    this.active = active;
    this.email = email;
  }
}
